(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4be9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4be9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;






var $iu98S = parcelRequire("iu98S");

var $gVu1Y = parcelRequire("gVu1Y");
// packages/collapse/src/index.js
function $00f0922781ce0936$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $00f0922781ce0936$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $00f0922781ce0936$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $00f0922781ce0936$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $00f0922781ce0936$export$2e2bcd8739ae039 = $00f0922781ce0936$export$ec45920981e0ca9b;



var $i0y78 = parcelRequire("i0y78");
// packages/intersect/src/index.js
function $22d7b5ed3c3d5952$export$1f4807a235930d45(Alpine) {
    Alpine.directive("intersect", Alpine.skipDuringClone((el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $22d7b5ed3c3d5952$var$getRootMargin(modifiers),
            threshold: $22d7b5ed3c3d5952$var$getThreshold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    }));
}
function $22d7b5ed3c3d5952$var$getThreshold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $22d7b5ed3c3d5952$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $22d7b5ed3c3d5952$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($22d7b5ed3c3d5952$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $22d7b5ed3c3d5952$export$2e2bcd8739ae039 = $22d7b5ed3c3d5952$export$1f4807a235930d45;


(0, $gVu1Y.default).plugin((0, $00f0922781ce0936$export$2e2bcd8739ae039));
(0, $gVu1Y.default).plugin((0, $i0y78.default));
(0, $gVu1Y.default).plugin((0, $22d7b5ed3c3d5952$export$2e2bcd8739ae039));
window.addEventListener('load', ()=>{
    // swiper 3 images
    var swiper_3img = new (0, $iu98S.default)(".swiper_3img", {
        modules: [
            (0, $iu98S.Navigation),
            (0, $iu98S.Pagination)
        ],
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        }
    });
    var swiper_impression = new (0, $iu98S.default)(".swiper-impression", {
        modules: [
            (0, $iu98S.Navigation),
            (0, $iu98S.Pagination)
        ],
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        }
    });
    window.MainNavigation = function() {
        return {
            mobileOpen: false,
            isSticky: false,
            init () {
                let checkSticky = ([e])=>{
                    this.isSticky = e.intersectionRatio < 1;
                };
                this.observer = new IntersectionObserver(checkSticky, {
                    threshold: [
                        1
                    ]
                });
                this.observer.observe(this.$el);
            }
        };
    };
    (0, $gVu1Y.default).start();
});

})();
//# sourceMappingURL=tailwind.b1d14985.js.map
